import { useTranslation } from "react-i18next";
import { FullWidthSectionWithContent } from "../../common/FullWidthSectionWithContent";
import styled from "styled-components";
import { GradientBackground } from "../../GradientBackground/GradientBackground";
import { COLORS } from "../../../assets/constants/styles";
import { Heading } from "../../common/Heading/Heading";
import { Button } from "../../common/Button/Button";
import { media } from "../../../styles/mixins";

import { openExtensionStore } from "../../../helpers/various-helpers";
import { trackEvent } from "../../../helpers/analytics-helpers";
export const Footer = () => {
  const { t } = useTranslation();

  return (
    <FullWidthSectionWithContent background={COLORS.violet}>
      <GradientBackground variant="footer" />
      <FooterContainer>
        <Heading text={t("footer.title")} color={COLORS.white} />
        <Caption>{t("footer.caption")}</Caption>
        <Button
          variant="green"
          text={t("footer.tryFree")}
          onClick={() => {
            // eslint-disable-next-line no-undef
            ym(100699774, "reachGoal", "TRY_NOW");
            trackEvent("try-now");
            openExtensionStore();
          }}
        />
      </FooterContainer>
    </FullWidthSectionWithContent>
  );
};

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 48px 0;

  ${media.tablet(`
    gap: 28px;
    padding: 80px 0;
  `)}
`;

const Caption = styled.div`
  color: ${COLORS.white};
`;
